import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import './LogIn.css';
import 'clientjs';
import { SetProfileInfo } from "../../actions/ActionsIndex";
import { IdentityService } from '../../services/IdentityService';
import { LoaderComponent } from '../../controls/Loader';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';
import { IUserInfo } from '../../models/IUserInfo';
import { ILoginModel } from '../../models/ILoginModel';
import { Tooltip } from '../Tooltip/Tooltip';
import { FormGroup } from '../../controls/Form/FormGroup';
import Footer from './Footer';
import { ImageContainer } from './ImageContainer';

function MapState(state) {
    return {
        UserInfo: state.Profile
    }
}
interface IState {
    Login: string;
    Password: string;
    invalidLoginAttempt: boolean;
    LoaderVisible: boolean;
    TooltipVisible?: boolean;
}
interface IProps extends RouteComponentProps<any> {
    HandleLogin: (info: IUserInfo) => void;
    UserInfo: IUserInfo | null;
}
export class LogInComponent extends Component<IProps, IState> {
    private client: any;
    private didSubmit = false;

    constructor(props: any) {
        super(props);

        let professionNumber = this.props.match.params.professionNumber;

        this.state = {
            invalidLoginAttempt: false,
            Login: professionNumber ? professionNumber : '',
            Password: '',
            LoaderVisible: false,
            TooltipVisible: false
        }

        this.client = new (window as any).ClientJS();

        const { UserInfo, history } = this.props;
        if (UserInfo !== null) {
            if (UserInfo.isAuthenticated === true) {
                history.push('/app/choose');
            }
        }
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.UserInfo !== null) {
            if (nextProps.UserInfo.isAuthenticated) {
                this.props.history.push('/app/choose');
            }
        }
    }

    public render() {
        const { LoaderVisible, TooltipVisible, Login, Password } = this.state;
        return (
            <div className="login-component route-component form-component login">
                <div className="content-container">
                    {this.RenderGoToHomeButton()}
                    <div
                        onClick={this.closeTooltip}
                        className="content">
                        <LoaderComponent Visible={LoaderVisible} />

                        <div className="form-container">
                            <div className="form-container__wrapper">
                                <div className="kif-logo" />
                                <div className="header">
                                    <h3>Witaj z powrotem!</h3>
                                </div>
                                <form onSubmit={this.onSubmit}>
                                    <FormGroup
                                        CustomLabel={
                                            <div className="flex-start-label">
                                                <label>Email lub numer PWZFz</label>
                                                <div
                                                    onClick={this.onInfoClick}
                                                    className="info-button">
                                                    {TooltipVisible && <Tooltip>Email lub numer prawa do wykonywania zawodu z bazy Krajowego Rejestru Fizjoterapeutów</Tooltip>}
                                                </div>
                                            </div>
                                        }
                                        Name="Login"
                                        OnChange={this.onInputChange}
                                        Value={Login}
                                        ValidationState={this.GetLoginValidation}
                                        ErrorBlock="Wpisz poprawny email lub numer PWZFz"
                                    />

                                    <FormGroup
                                        CustomLabel={
                                            <div className="space-between-label">
                                                <label>Hasło</label>
                                                <span
                                                    className="password-recovery"
                                                    onClick={this.RedirectToPasswordRecovery}>
                                                    Zapomniałeś hasła?
                                                </span>
                                            </div>
                                        }
                                        Name="Password"
                                        OnChange={this.onInputChange}
                                        Value={Password}
                                        ValidationState={this.GetPasswordValidation}
                                        ErrorBlock="Wpisz hasło"
                                        Type="password"
                                    />
                                    <div className="form-buttons">
                                        <input type="submit" className="confirm-button-orange" value="Zaloguj się" />
                                    </div>
                                </form>
                                <span className="bottom-redirect">Nie masz jeszcze konta? <a onClick={this.RedirectToRegister}>Zarejestruj się</a></span>
                            </div>

                        </div>
                        <ImageContainer />
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }//end-of-render

    private GetLoginValidation = (): "success" | "warning" | "error" | undefined => {
        const { Login } = this.state;
        if (this.didSubmit) {
            if (Login && Login.length > 0) {
                return Login.length < 320 ? "success" : "error";
            } else {
                return "error";
            }
        } else {
            return undefined;
        }
    }

    private GetPasswordValidation = (): "success" | "warning" | "error" | undefined => {
        const { Password } = this.state;
        if (this.didSubmit) {
            if (Password && Password.length > 0) {
                return "success";
            } else {
                return "error";
            }
        } else {
            return undefined;
        }
    }

    private RenderGoToHomeButton = () => {
        const { UserInfo } = this.props;
        if (UserInfo !== null) {
            if (UserInfo.redirectUrl !== undefined &&
                UserInfo.redirectUrl !== null &&
                UserInfo.redirectUrl !== ""
            ) {
                return (
                    <div className="top-buttons">
                        <div className="go-back-button" onClick={this.GoToHome}>powrót do serwisu</div>
                    </div>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    private onInfoClick = (e) => {
        e.stopPropagation();
        this.setState({
            TooltipVisible: !this.state.TooltipVisible
        });
    }

    private closeTooltip = () => {
        this.setState({
            TooltipVisible: false
        });
    }

    private onInputChange = (event) => {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        this.setState(partialState);
    }

    private onLoginSuccess = (resultInfo: IUserInfo): void => {
        const { UserInfo, HandleLogin, history } = this.props;
        if (UserInfo !== null) {
            UserInfo.isAuthenticated = true;
        }
        this.setState({
            LoaderVisible: false
        });
        if (resultInfo !== null &&
            resultInfo.redirectUrl !== null &&
            resultInfo.redirectUrl !== undefined &&
            resultInfo.redirectUrl !== ""
        ) {

            window.location.href = resultInfo.redirectUrl;
        } else {
            HandleLogin(resultInfo)
            history.push('/app/choose');
        }

    }

    private onLoginError = (status: number, error: string): void => {
        this.setState({
            invalidLoginAttempt: true,
            LoaderVisible: false
        });
        if (error === "lockedout") {
            ShowStatusBar('Error', 'Hasło zostało błędnie wprowadzone 5 razy, dlatego zablokowaliśmy konto. Spróbuj ponownie za 5 minut.', DEFAULT_STATUS_TIMEOUT);
        } else if (error === "notConfirmed") {
            ShowStatusBar('Error', 'Adres email nie został potwierdzony.', undefined, "Wyślij link aktywacyjny ponownie", this.ResendActivationLink);
        } else if (error === "wrongPassword") {
            ShowStatusBar('Error', 'Próba logowania nie udała się, sprawdź login oraz hasło.', DEFAULT_STATUS_TIMEOUT);
        } else {
            ShowStatusBar('Error', 'Próba logowania nie udała się, spróbuj ponownie.', DEFAULT_STATUS_TIMEOUT);
        }
    }

    private ResendActivationLink = () => {
        console.log('resend')
        let service = new IdentityService();
        service.RegenerateConfirm(this.state.Login,
            () => {
                ShowStatusBar("Success", "Link aktywacyjny wysłany.")
            },
            () => {
                ShowStatusBar("Error", "Nie udało się wysłac ponownie linku aktywacyjnego.")
            }
        );
    }

    private onSubmit = (event) => {
        this.didSubmit = true;
        const { Login, Password } = this.state;
        this.setState({
            LoaderVisible: true
        });

        let loginData: ILoginModel = {
            Username: Login,
            Password,
            Fingerprint: this.client.getFingerprint(),
            UserAgent: this.client.getUserAgentLowerCase(),
            Browser: this.client.getBrowser(),
            BrowserVersion: this.client.getBrowserVersion(),
            OS: this.client.getOS(),
            OsVersion: this.client.getOSVersion(),
            Engine: this.client.getEngine(),
            EngineVersion: this.client.getEngineVersion(),
            ScreenResolution: this.client.getCurrentResolution()
        };
        let service = new IdentityService();
        service.LogIn(loginData, this.onLoginSuccess, this.onLoginError);
        event.preventDefault();
    }

    private RedirectToRegister = (evt) => {
        this.props.history.push('/register');
    }

    private RedirectToPasswordRecovery = (evt) => {
        this.props.history.push('/passwordrecovery');
    }

    private GoToHome = (evt) => {
        const { UserInfo } = this.props;
        if (UserInfo !== null) {
            window.location.href = UserInfo.redirectUrl;
        }
    }
}

export default connect(MapState, { HandleLogin: SetProfileInfo })(LogInComponent);


// WEBPACK FOOTER //
// ./src/components/Login/LogIn.tsx